<div class="video-player">
  @if (showInitial) {
    <div (click)="togglePlay()" class="video-initial-play">
      <button [attr.tabindex]="currentTabIndex()" [attr.aria-label]="'cl_chat.playVideo' | translate">
        <i class="mi2-play text-[48px] text-surface-0"></i>
      </button>
    </div>
  }
  @if (showControls) {
    <div @fadeInOut class="video-controls">
      <div class="play">
        <button
          (click)="togglePlay()"
          [attr.tabindex]="currentTabIndex()"
          [attr.aria-label]="(isPaused ? 'cl_chat.playVideo' : 'cl_chat.pauseVideo') | translate"
        >
          @if (isPaused) {
            <i class="mi2-play-circle text-[20px] text-surface-0"></i>
          } @else {
            <i class="mi2-pause-circle text-[20px] text-surface-0"></i>
          }
        </button>
      </div>
      <div class="seeker">
        <div class="filled" [style.flex-basis.%]="currentPercent"></div>
      </div>
      <div class="duration">
        {{ currentTime }}
        @if (showDuration) {
          <ng-container>/ {{ duration }}</ng-container>
        }
      </div>
      <div class="controls">
        <button
          class="volume"
          (click)="toggleVolume()"
          [attr.tabindex]="currentTabIndex()"
          [attr.aria-label]="(isMuted ? 'cl_chat.unmute' : 'cl_chat.mute') | translate"
        >
          @if (isMuted) {
            <i class="mi2-speaker-off-filled text-[20px] text-surface-0"></i>
          } @else {
            <i class="mi2-speaker-on-filled text-[20px] text-surface-0"></i>
          }
        </button>
        <button
          (click)="toggleFullScreen()"
          [attr.tabindex]="currentTabIndex()"
          [attr.aria-label]="'cl_chat.enterFullscreen' | translate"
        >
          <i class="mi2-full-screen text-[20px] text-surface-0"></i>
        </button>
      </div>
    </div>
  }
  @if (hasMediaError) {
    <div class="video-error" role="alert">
      <i class="mi2-warning text-[48px] text-red-500"></i>
      <span class="video-error-text">{{ 'cl_chat.failedToLoadAttachment' | translate }}</span>
    </div>
  }
  <video
    #videoElement
    allowfullscreen="true"
    webkitallowfullscreen="true"
    mozallowfullscreen="true"
    controlsList="nodownload"
  >
    <source #srcEl type="video/mp4" />
  </video>
</div>
